export default ({ request }) => ({
  ecomAmzRecordSettlementListApi(data = {}) {
    return request({
      url: '/ecom/amz/record/settlement/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzRecordSettlementTotalApi(data = {}) {
    return request({
      url: '/ecom/amz/record/settlement/total',
      method: 'POST',
      data,
    })
  },
})
